import { connect } from 'react-redux'
import qs from 'qs'
import { compose, withHandlers, withState, withProps } from 'recompose'
import { APP_URL } from 'constants/ResourcesConstants'

import * as EmbedSelectors from 'app/modules/embed/selectors'

import Unsubscription from './component'


const mapStateToProps = state => ({
  embedId: EmbedSelectors.getEmbedId(state),
})

export default compose(
  connect(mapStateToProps),
  withState('endUserEmail', 'setEndUserEmail', ''),
  withState('isCopied', 'setIsCopied', false),
  withHandlers({
    onEndUserEmailChange: props => e => {
      props.setEndUserEmail(e.target.value)
    },
    handleCopyUnsubLink: props => () => {
      props.setIsCopied(true)

      setTimeout(() => {
        props.setIsCopied(false)
      }, 1800)
    },
  }),
  withProps(props => ({
    unsubLink: `${APP_URL}/unsubscribe?${qs.stringify({ embedId: props.embedId, identifier: window.btoa(props.endUserEmail) })}`
  })),
)(Unsubscription)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Unsubscription/index.js